import PropTypes from 'prop-types'

const { string, number, bool } = PropTypes

export const CardDetails = {
  id: string,
  cardBrand: string,
  maskedCardNumber: string.isRequired,
  expiryMonth: number,
  expiryYear: number.isRequired,
  cardholderName: string.isRequired,
  isExpired: bool.isRequired,
  billingAddress: PropTypes.exact({
    addressLine1: string,
    addressLine2: string,
    city: string,
    postalCode: string,
    country: string,
  }),
}

export const Booking = {
  amount: number,
  country: string,
  currency: string,
  salesOrderId: string,
  organizationId: string,
  redirectUrl: string,
  errorUrl: string,
  cancelUrl: string,
  checksum: string,
  numberOfPassengers: number,
  userId: string,
  expiryDate: string,
  timeoutUrl: string,
  failureUrl: string,
  currentPaymentPlan: PropTypes.exact({
    count: number,
    amount: number,
  }),
}
